import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import HeroBannerBlock from './heroBannerBlock.vue';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';
import './c-hero-banner-block.scss';

async function mountHeroBannerBlock() {
	const heroBannerBlock = document.getElementById('hero-banner-block');

	if (!heroBannerBlock) {
		console.warn('[HeroBannerBlock] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	const app = createApp({
		name: 'HeroBannerBlockApp',
	});
	app.component('hero-banner-block', HeroBannerBlock);
	app.component(
		'send-campaign-id-cta-button',
		defineAsyncComponent(
			() =>
				import('shared/components/actionButtonWithCTA/SendCampaignIdCtaButton.vue'),
		),
	);
	app.component(
		'cta-button-with-popup-form',
		defineAsyncComponent(
			() =>
				import('shared/components/actionButtonWithCTA/CtaButtonWithPopupForm.vue'),
		),
	);
	app.component(
		'form-kit-builder-container',
		defineAsyncComponent(
			() =>
				import('shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue'),
		),
	);
	await initFormKitSchema(app, options);
	app.use(store);
	app.mount(heroBannerBlock);
}

mountHeroBannerBlock().catch((error) => {
	console.error('Error mounting HeroBannerBlock:', error);
});

